import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslate } from '../../../context/TranslationsContext.js';
import Footer from '../../Footer/index.js';
import Header from '../../Header/index.js';
import IconButton from '../../IconButton/IconButton.js';
import Text from '../../Text/index.js';
import CloseIcon from '../../UserPreferencesPanel/CloseIcon.js';
import PreferencesCategories from '../../UserPreferencesPanel/PreferencesCategories.js';
import Layout from '../Layout.js';
export default function PreferencesView({ layout, setView, NotificationPreferences = PreferencesCategories, }) {
    const t = useTranslate();
    return (_jsxs(Layout, { order: layout, children: [_jsx(Header, { title: _jsx(Text, { id: "preferences.title", defaultMessage: "Preferences" }), actions: _jsx(IconButton, { onClick: () => setView('inbox'), "aria-label": t('preferences.close', 'Close preferences'), children: _jsx(CloseIcon, {}) }) }, "header"), _jsx("div", { css: { flex: 1, overflowY: 'hidden' }, children: _jsx(NotificationPreferences, {}) }, "content"), _jsx(Footer, {}, "footer")] }));
}
//# sourceMappingURL=PreferencesView.js.map